// import Main from '@/view/main'

export default {
  path: 'account',
  meta: {
    title: '应收款流水',
  },
  name: 'cache-account',
  component: () => import('@/components/parent-view'),
  children: [
    {
      path: 'list',
      name: 'cache-self-account-list',
      meta: {
        title: '应收账款',
      },
      component: () => import('@/view/v5/account/index.vue'),
    },
    {
      path: 'company',
      name: 'cache-self-account-company',
      meta: {
        title: '企业详情',
      },
      component: () => import('@/view/v5/account/company.vue')
    }
  ]
}



// WEBPACK FOOTER //
// ./src/router/routes/v5/account.js